import { useEffect, useState } from "react";
import { motion, AnimatePresence } from "framer-motion";
import { ChevronLeft, ChevronRight, Quote } from "lucide-react";
import { Reveal, SectionHeading } from "@/components/Reveal";

export default function Testimonials({ items }) {
  const [idx, setIdx] = useState(0);

  useEffect(() => {
    const t = setInterval(() => setIdx((i) => (i + 1) % items.length), 7000);
    return () => clearInterval(t);
  }, [items.length]);

  const item = items[idx];

  return (
    <section id="testimonials" className="py-28 lg:py-36 spotlight-fuchsia" data-testid="testimonials-section">
      <div className="max-w-3xl mx-auto px-5 lg:px-8 text-center">
        <SectionHeading
          eyebrow="Testimonials"
          title={<>Stories from <span className="gold-text">the Stage</span></>}
          testId="testimonials-heading"
        />
        <Reveal>
          <div className="relative glass-card rounded-md px-8 sm:px-14 py-14" data-testid="testimonial-carousel">
            <Quote className="mx-auto text-gold/60 mb-8" size={36} />
            <AnimatePresence mode="wait">
              <motion.blockquote
                key={item.id}
                initial={{ opacity: 0, y: 24 }}
                animate={{ opacity: 1, y: 0 }}
                exit={{ opacity: 0, y: -24 }}
                transition={{ duration: 0.6 }}
              >
                <p className="font-display italic text-xl sm:text-2xl leading-relaxed text-cream/90" data-testid="testimonial-quote">
                  “{item.quote}”
                </p>
                <footer className="mt-8">
                  <p className="text-gold font-semibold tracking-widest text-sm uppercase">{item.name}</p>
                  <p className="text-muted text-xs mt-1 tracking-wide">{item.title}</p>
                </footer>
              </motion.blockquote>
            </AnimatePresence>
            <div className="mt-10 flex items-center justify-center gap-6">
              <button onClick={() => setIdx((idx - 1 + items.length) % items.length)} className="text-gold/70 hover:text-gold transition-colors" aria-label="Previous testimonial" data-testid="testimonial-prev">
                <ChevronLeft size={24} />
              </button>
              <div className="flex gap-2">
                {items.map((t, i) => (
                  <button key={t.id} onClick={() => setIdx(i)} aria-label={`Testimonial ${i + 1}`} data-testid={`testimonial-dot-${i}`}
                    className={`h-1.5 rounded-full transition-all duration-500 ${i === idx ? "w-8 bg-gold" : "w-3 bg-gold/25"}`} />
                ))}
              </div>
              <button onClick={() => setIdx((idx + 1) % items.length)} className="text-gold/70 hover:text-gold transition-colors" aria-label="Next testimonial" data-testid="testimonial-next">
                <ChevronRight size={24} />
              </button>
            </div>
          </div>
        </Reveal>
        <Reveal delay={0.2}>
          <p className="mt-6 text-xs text-muted/70" data-testid="testimonials-placeholder-note">
            Sample testimonials — to be replaced with genuine participant stories.
          </p>
        </Reveal>
      </div>
    </section>
  );
}
